import { TranslationKey } from '@/types/i18n.types';

export enum OMNI_SETUP_STEPS_KEYS {
  INSTALL_BLOCKSITE = 'installBlocksite',
  ADD_ITEM_TO_BLOCKSITE = 'addItemToBlockSite',
  ENABLE_BLOCKING_BY_CATEGORY = 'enableBlockingByCategory',
  TRY_VISIT_BLOCKED_SITE = 'tryVisitBlockedSite',
  GET_PERSONALIZED_SUGGESTIONS = 'getPersonalizedSuggestions',
  PIN_EXTENSION = 'pinExtension',
  SEE_INSIGHTS = 'seeInsights',
  GET_MOBILE_LINK = 'getMobileLink',
}

export interface IOmniSetupItem {
  key: OMNI_SETUP_STEPS_KEYS;
  isChecked: boolean;
  label: TranslationKey;
  weight: number;
}

export interface IOmniSetup {
  items: IOmniSetupItem[];
  isMinimized: boolean;
  isPostInstall: boolean;
  isFinished: boolean;
  snoozeTS: number;
}
